import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " Welcome to Johnson Inspection Permit Application Portal ")
], -1)
const _hoisted_2 = { class: "space-y-6 mt-4 max-w-screen-sm mx-auto" }
const _hoisted_3 = { class: "card p-6" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-2 text-base font-semibold leading-6 text-gray-900" }, " New Application ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " To submit a new application ", -1)
const _hoisted_7 = { class: "mt-6 w-full sm:flex sm:justify-center" }
const _hoisted_8 = { class: "card p-6" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-2 text-base font-semibold leading-6 text-gray-900" }, " Previous Applications ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " To look up previous applications, enter your email below ", -1)
const _hoisted_12 = ["onSubmit"]

import api from '@/utilities/api'

	import {
		MagnifyingGlassIcon,
		FolderPlusIcon
	} from '@heroicons/vue/24/outline'

	import {
		ref
	} from 'vue'

	
	const __default__ = { name: 'LandingPage' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const email = ref("")
	const sendEmailLoading = ref(false)
	const responseMessage = ref("")
	const responseCode = ref(0)

	async function sendEmail() {
		try {
			sendEmailLoading.value = true
			let payload = {
				email: email.value
			}
	
			const body = {
				action: "sendEmailLink",
				payload: payload,
			}
	
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			
			responseCode.value = JSON.parse(response.response.scriptResult).messages.code
			responseMessage.value = JSON.parse(response.response.scriptResult).result.data
		}
		catch(e) {
			console.log(e)
		}
		finally {
			sendEmailLoading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(FolderPlusIcon), { class: "w-6 h-6 mx-auto" }),
          _hoisted_5,
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: {name: 'ApplicationForm'} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_button, {
                class: "w-full sm:w-56 mx-auto",
                color: "amber"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Create New Application ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(MagnifyingGlassIcon), { class: "w-6 h-6 mx-auto" }),
          _hoisted_10,
          _hoisted_11
        ]),
        _createElementVNode("form", {
          onSubmit: _withModifiers(sendEmail, ["prevent"]),
          class: "mt-6 sm:flex sm:items-end gap-4 justify-center",
          action: "#"
        }, [
          _createVNode(_component_v_input, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            "aria-label": "Email address",
            class: "w-full sm:max-w-96",
            type: "email",
            name: "email",
            placeholder: "Enter your email"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_button, {
            class: "w-full mt-4 sm:mt-0 sm:w-36",
            color: "amber",
            onClick: _withModifiers(sendEmail, ["prevent"]),
            disabled: !email.value,
            type: "submit",
            loading: sendEmailLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Send Email ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"])
        ], 40, _hoisted_12),
        _createElementVNode("p", {
          class: _normalizeClass([{'text-red-500': responseCode.value != 0}, 'mt-3 text-sm'])
        }, _toDisplayString(responseMessage.value), 3)
      ])
    ])
  ], 64))
}
}

})